import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyBookingsState = ({ hasFilters, onResetFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="Calendar" size={48} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="font-heading font-semibold text-xl text-foreground mb-2">
        {hasFilters ? 'No bookings found' : 'No bookings yet'}
      </h3>
      
      <p className="text-muted-foreground font-caption text-center max-w-md mb-6">
        {hasFilters 
          ? 'Try adjusting your filters to see more results.' :'Bookings will appear here once clients start making appointments through your booking system.'}
      </p>

      {hasFilters && (
        <Button
          variant="outline"
          iconName="RotateCcw"
          onClick={onResetFilters}
        >
          Reset Filters
        </Button>
      )}
    </div>
  );
};

export default EmptyBookingsState;